// extracted by mini-css-extract-plugin
export default {"sectionContentImage":"BlockImage_sectionContentImage__QforJ","image":"BlockImage_image__fqop5"};